import InfiniteScroll from 'infinite-scroll';
import gsap from 'gsap';
import StickyButton from "../components/stickyButton";

class Blog {
  constructor() {
    this.infinityScroll();
  }

  infinityScroll() {
    const container = window.wrapper.querySelector('.blog__posts__grid');
    const button = window.wrapper.querySelector('.load-more');
    if (!button)
      return
    this.infiniteScroll = new InfiniteScroll(container, {
      path: '.load-more',
      button: '.load-more',
      append: '.blog__posts__post',
      scrollThreshold: false,
      status: '.page-load-status',
      onInit() {
        this.on('append', (response, path, items) => {
          window.lazyLoad.update();

          gsap.set(items, {
            autoAlpha: 0,
            y: 30
          });

          gsap.to(items, {
            autoAlpha: 1,
            y: 0,
            stagger: 0.1
          });

          [].forEach.call(items, (item) => {
            const links = item.querySelectorAll('a');
            [].forEach.call(links, (link) => {
              const posttype = link.dataset.type ? link.dataset.type : null;
              link.addEventListener('mouseenter', () => window.cursor.enter(posttype));
              link.addEventListener('mouseleave', () => window.cursor.leave(posttype));
            });

            const buttons = item.querySelectorAll('.button--anim');
            [].forEach.call(buttons, (button) => {
              return new StickyButton(button);
            });
          });
        });
      }
    });
  }

  removeListeners() {
    if (this.infiniteScroll) {
      this.infiniteScroll.destroy();
    }
  }
}

export default Blog;
